import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { DELIVERY_MODEL_TYPE } from '../../types';
import type { PlacesWithLocation } from '../../types';

import { image } from '@/Themes/Images';

function MarkerPlace({
  place,
  index,
}: {
  place: PlacesWithLocation;
  index: number;
}) {
  const pointerIconPlaceWithDelivery = new L.Icon({
    iconUrl: image.marker_place,
    iconAnchor: [20, 45],
    popupAnchor: [10, -44],
    iconSize: [40, 45],
  });

  const pointerIconPlaceWithPendingOrder = new L.Icon({
    iconUrl: image.marker_place_pending_order,
    iconAnchor: [20, 45],
    popupAnchor: [10, -44],
    iconSize: [40, 45],
  });

  if (!place.localization) {
    return null;
  }

  const PLACE_TYPE_LABEL: Record<DELIVERY_MODEL_TYPE, string> = {
    [DELIVERY_MODEL_TYPE.CLOUD]: 'Loja nuvem',
    [DELIVERY_MODEL_TYPE.LINKED]: 'Loja próprio',
    [DELIVERY_MODEL_TYPE.CLOUD_AND_LINKED]: 'Loja nuvem e próprio',
  };

  return (
    <Marker
      icon={
        place.pendingDeliveriesCount > 0
          ? pointerIconPlaceWithPendingOrder
          : pointerIconPlaceWithDelivery
      }
      key={index}
      position={[
        place.localization.coordinates[1],
        place.localization.coordinates[0],
      ]}
    >
      <Popup>
        <div>
          <div>
            <strong>Nome: </strong>
            <span>{place.placeName}</span>
          </div>
          <div>
            <strong>Quantidade de entregas em andamento: </strong>
            <span>{place.inProgressDeliveriesCount}</span>
          </div>
          <div>
            <strong>Quantidade de entregas pendentes: </strong>
            <span>{place.pendingDeliveriesCount}</span>
          </div>
          {place.placeType && (
            <div>
              <strong>Tipo: </strong>
              <span>{PLACE_TYPE_LABEL[place.placeType]}</span>
            </div>
          )}
        </div>
      </Popup>
    </Marker>
  );
}

export { MarkerPlace };
